<template>
  <div v-show="isShow">
    <div class="sp-mask"></div>
    <div class="sp-panel">
      <div class="sp-title">
        <h1>单路段共享</h1>
        <button @click="hidePanel">×</button>
      </div>
      <div class="sp-wrap">
        <div class="item">
          <p class="item-title">起点</p>
          <input
            type="text"
            class="item-text"
            :value="roadData.length > 0 && roadData[0].address_start"
          />
        </div>
        <div class="item">
          <p class="item-title">终点</p>
          <input
            type="text"
            class="item-text"
            :value="roadData.length > 0 && roadData[0].address_end"
          />
        </div>
        <div class="item" v-if="roadData.length > 0">
          <p class="item-title">详情</p>
          <input
            type="text"
            class="item-text"
            :value="
              roadData[0].transit && '路程为：' + roadData[0].transit.distance
            "
          />
          <input
            type="text"
            class="item-text"
            :value="
              roadData[0].transit && '时长为：' + roadData[0].transit.duration
            "
          />
        </div>
        <div class="item">
          <p class="item-title">约定时间</p>
          <input
            type="datetime-local"
            class="item-text"
            @change="changeDate($event)"
            v-model="defineTime"
          />
        </div>
        <div class="item">
          <p class="item-title">留言</p>
          <textarea type="text" class="item-textarea" v-model="userMessage" />
        </div>
      </div>
      <div class="sp-footer">
        <div class="marked-opera">
          <!-- <button id="link-copy" @click="copyMarkedLink">
            <span></span> 复制标记链接
          </button> -->
          <!-- <button id="link-share"><span></span> 分享</button> -->
          <button id="marked-save" @click="handleSave">
            <span></span> 保存标记
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { diffDate } from "../assets/js/formatTime.js";
import { randomWord } from "../assets/js/tool.js";

export default {
  props: {
    roadData: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      isShow: false,
      userMessage: "",
      defineTime: "",
    };
  },
  mounted() {
    console.log(this.roadData[0]);
  },
  methods: {
    showPanel() {
      this.isShow = true;
      console.log(this.roadData);
    },
    hidePanel() {
      this.isShow = false;
    },
    changeDate(e) {
      this.defineTime = e.target.value;
      console.log(diffDate(e.target.value));
    },
    copyMarkedLink() {
      let oURI = document.createElement("input");
      let roadsList = JSON.stringify(...this.roadData);
      oURI.value = `http://map.ayane.io/?roadsList=${roadsList}`;
      document.body.appendChild(oURI);
      oURI.select();
      document.execCommand("Copy");
      document.body.removeChild(oURI);
      alert("复制成功");
    },
    handleSave() {
      let _this = this;
      let startAddress = this.roadData[0].address_start;
      let startPoint = this.roadData[0].start;
      let endAddress = this.roadData[0].address_end;
      let endPoint = this.roadData[0].end;
      let distance = this.roadData[0].transit.distance;
      let duration = this.roadData[0].transit.duration;
      let message = this.userMessage;
      let time = this.defineTime;

      this.$http
        .post("/service/addRoad", {
          type: "road",
          startAddress,
          startPoint,
          endAddress,
          endPoint,
          distance,
          duration,
          message,
          time,
        })
        .then(function (oRes) {
          oRes = oRes.data;
          var link = `http://map.ayane.io/?ms=${oRes.id}`;
          _this.hidePanel();
          _this.$emit("openCopyCard", link);
          // console.log(oRes);
          // let oURI = document.createElement("input");
          // oURI.value = `localhost:8080/?ms=${oRes.id}`;
          // document.body.appendChild(oURI);
          // oURI.select();
          // document.execCommand("Copy");
          // document.body.removeChild(oURI);
          // alert("复制成功");
          // 将id存入cookie中
          let cookieArr = new Object(); // Cookies 数组对象
          let cookieName = "road" + randomWord(false, 8); // Cookie 名称
          cookieArr.name = cookieName;
          cookieArr.id = oRes.id;
          cookieArr.type = "road";
          _this.$cookies.set(cookieName, cookieArr, "30d");
          console.log("保存成功");
          console.log(cookieArr);
          console.log(_this.$cookies.keys());
        });
    },
  },
};
</script>

<style lang="less" scoped>
@import "../assets/less/ShareRoad.less";
</style>
